// extracted by mini-css-extract-plugin
export var featured_articles = "ArticlesSidebar-module--featured_articles--FRvde";
export var featured_article = "ArticlesSidebar-module--featured_article--8qMWX";